import { Button } from "@/components/ui/button";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH. window.location.origin is the ONLY source of truth
 * for the redirect back into our app.
 */
export default function GoogleAuthButton({ testId = "google-signin" }) {
  const onClick = () => {
    const next = new URLSearchParams(window.location.search).get("next");
    if (next && next.startsWith("/")) localStorage.setItem("vsk_next", next);
    else localStorage.removeItem("vsk_next");
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button
      type="button"
      onClick={onClick}
      variant="outline"
      data-testid={testId}
      className="w-full bg-transparent border-white/20 text-white hover:bg-white/5 hover:text-white rounded-full h-11 font-semibold flex items-center justify-center gap-3"
    >
      <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20.4H24v7.2h11.3c-1.5 4.3-5.6 7.4-11.3 7.4-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.1-5.1C33.6 6.5 29 4.4 24 4.4 13.2 4.4 4.4 13.2 4.4 24S13.2 43.6 24 43.6c11 0 20-8 20-19.6 0-1.3-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l5.9 4.3C13.8 15 18.5 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.1-5.1C33.6 6.5 29 4.4 24 4.4 16.2 4.4 9.4 8.9 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 43.6c5 0 9.5-1.9 12.9-5l-6-4.9c-1.8 1.3-4.2 2.1-6.9 2.1-5.7 0-10.5-3.6-12.2-8.7l-6 4.6C8.7 38.9 15.8 43.6 24 43.6z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20.4H24v7.2h11.3c-.7 2-2 3.7-3.7 5l6 4.9c-.4.4 6.4-4.7 6.4-14 0-1.3-.1-2.3-.4-3.5z"/>
      </svg>
      Continue with Google
    </Button>
  );
}
